import { useTranslation } from "react-i18next";
import { TextButton } from "@/components/common/text-button";
import { Image } from "@/components/common/image";
import { Video } from "@/components/common/video";
import { Spinner } from "@/components/ui/modal";
import { cn } from "@/utils/cn";

export interface UploadFormProps {
  className?: string;
  uploadType: "image" | "video";
  URL: string;
}

export const VerifyForm = ({ className, uploadType, URL }: UploadFormProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "flex-1 flex flex-col h-full items-center justify-center px-20 gap-8",
        className
      )}
    >
      <div
        className={cn(
          "relative overflow-hidden flex-1 h-full flex flex-col items-center justify-center rounded-2xl w-full text-center transition-colors cursor-pointer",
          "border-2 border-dashed border-[rgba(208,213,221,1)] hover:border-[rgba(102,112,133,1)]",
          "bg-[rgba(249,250,251,1)]"
        )}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          {uploadType === "image" ? (
            <Image className="h-full rounded-xl" src={URL} />
          ) : (
            <Video className="h-full rounded-xl" src={URL} />
          )}
          <div className="absolute inset-0 flex flex-col justify-center items-center gap-1 bg-black/30">
            <Spinner className="w-6 h-6 text-white" />
          </div>
        </div>
      </div>
      <TextButton className="w-80" label={t("custom_digital_human.upload_form.next")} disabled />
    </div>
  );
};
